import { Loader } from './Loader'
import { LoaderOverlayWrapper } from './LoaderOverlayWrapper'
import LoaderSVG from './LoaderSVG'
import LoaderWrapper, { LoaderWrapperProps } from './LoaderWrapper'
import { SmartLoaderWrapper } from './SmartLoaderWrapper'
export default LoaderWrapper
export { LoaderWrapper, LoaderSVG, Loader, LoaderOverlayWrapper, SmartLoaderWrapper }
export type { LoaderWrapperProps }
